<template>
    <v-app id="app">
        <v-container class="my-15 px-10 text-body-1 monsterrat">
                <v-layout row>
                    <v-flex>

                         <v-row>
                            <v-col>
                              <p class="text-sm-h4 text-h5 text-md-h4 font-weight-bold monsterrat"> <span> Level Test - Intermediate </span> </p>
                           
                              <p class="font-weight-bold text-body-2 text-lg-h6 text-md-h6 monsterrat "> <span class="font-weight-medium"> Please do the following activities. </span> </p>
                            </v-col>
                      </v-row>

                      <v-layout row wrap class="mt-5" justify-sm-center>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 2. Repetition </span></p> 
                                
                                  <v-card class="px-2 py-lg-4 pb-lg-10 py-md-5 py-10 red lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Please repeat exactly how you heard the sentences. (Choose 2.).</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                
                                                  <v-card class="white px-5 py-5 elevation-0 text-lg-body-1 text-md-body-2">
                                                        <v-layout row wrap >
                                                            <v-flex md6>
                                                                <v-col>
                                                                        1. Sam baked the cake yesterday.

                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                        2. I will visit your school later.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                       3. She was cooking a while ago.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                      4. Mom was sleeping when dad arrived.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                        5. Jane visited Dave in the hospital.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                6. Billy likes going to parties.
                                                                </v-col>
                                                            </v-flex>
                                                            
                                                            
                                                        </v-layout>
                                                    
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 3. Sentence Construction </span></p> 
                                
                                  <v-card class="px-2 py-lg-10 pb-lg-16 py-md-10 py-10 red lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Make one sentence for each word given.</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                         <v-layout justify-center>
                                            <v-flex xs6 lg12 md12>
                                                
                                                  
                                                        <v-layout row wrap justify-lg-space-around  justify-md-space-around  class="mt-2">
                                                            <v-flex md5 xs12  class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-5 elevation-0">
                                                                   <v-img src="../../../../../assets/images/LevelTest/leveltest/cost.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg 4 md2 justify-center class="mt-2"><span> cost  </span></v-layout>
                                                                </v-card>
                                                            </v-flex>
                                                            <v-flex md5 xs12 class="mt-sm-4 mt-4">
                                                                <v-card class="py-5 px-5 elevation-0">
                                                                   <v-img src="../../../../../assets/images/LevelTest/leveltest/relax.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                    <v-layout xs6 lg 4 md2 justify-center class="mt-2"><span> relax  </span></v-layout>
                                                                </v-card>
                                                            </v-flex>
                                                            
                                                            
                                                        </v-layout>
                                                    
                                                 
                                            </v-flex>
                                         </v-layout>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 4. Freetalking </span></p> 
                                
                                  <v-card class="px-2 py-lg-5 py-md-4 py-10 red lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Please answer the questions the best way you can. (Choose 2.)</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="white px-5 py-5 elevation-0 text-lg-body-1 text-md-body-2">
                                                    <p >
                                                       1. When and where was your last vacation?

                                                    </p>
                                                    <p >
                                                        2. How do you celebrate the New Year?

                                                    </p>
                                                    <p >
                                                        3. Where do you want to spend your summer vacation?

                                                    </p>
                                                    <p >
                                                     4. What is the most famous place for tourists in Korea?
                                                         Why?

                                                    </p>
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                             <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold">  Reminders </span></p> 
                                
                                  <v-card class="px-2 py-lg-6 pb-lg-7 py-md-10 py-10  red lighten-5 elevation-0 rounded-xl">

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="px-5 py-10 elevation-0 text-center red lighten-5">

                                                   <div> Reintroduce yourself after completing the activities.</div>
                                                  <div class="mt-1">  Thank the student. </div>
                                                  <div class="mt-1">  Tell the student that they can check their results within today.  </div>
                                                  <div class="mt-1">  If they have any questions, they can visit our website.   </div>

                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>


                      </v-layout>

                    </v-flex>
                </v-layout>
        </v-container>
    </v-app>
</template>
<script>
export default {
    name : 'Intermediate'
}
</script>
<style scoped>
.monsterrat {
    font-family: 'Montserrat', serif !important;
}
</style>